// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hidden":"CheckInternet__hidden___Ds6FZ","overlay":"CheckInternet__overlay___12YrG","errorBox":"CheckInternet__errorBox___2xm_q","explanation":"CheckInternet__explanation___kqn0f"};
    if(module.hot) {
      // 1778083490284
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  